import React from 'react';
import { motion } from 'framer-motion';
export function ProductSection() {
  const modules = ['Fundamentos', 'Conversión', 'Comunicación', 'Estrategias', 'Mentalidad'];
  return <section className="bg-navy text-cream py-24 px-5" data-id="element-142">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-16" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="w-full md:w-1/2" data-id="element-144">
          <div className="relative" data-id="element-145">
            <div className="absolute inset-0 bg-gold/10 blur-[40px] rounded-full" data-id="element-146"></div>
            <img src="https://cdn.magicpatterns.com/uploads/7UfTeQJhri4ujhzd1D84PF/mock_up_3.png" alt="Ebook Modules" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-147" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="w-full md:w-1/2" data-id="element-148">
          <h2 className="font-playfair text-3xl md:text-5xl font-bold mb-10 leading-tight" data-id="element-149">
            Cinco módulos con{' '}
            <span className="text-gold italic" data-id="element-150">ejemplos reales</span>
          </h2>

          <div className="space-y-4" data-id="element-151">
            {modules.map((mod, index) => <div key={index} className="flex items-center gap-4 border-b border-gold/10 pb-4" data-id="element-152">
                <span className="font-playfair text-gold text-xl font-bold w-8" data-id="element-153">
                  0{index + 1}.
                </span>
                <h3 className="font-dmsans text-xl text-cream/90" data-id="element-154">{mod}</h3>
              </div>)}
          </div>

          <div className="mt-10" data-id="element-155">
            <a href="#oferta" className="inline-block w-full md:w-auto bg-gold text-navy font-dmsans font-bold text-lg py-4 px-8 rounded hover:bg-cream transition-colors text-center" data-id="element-156">
              Ver oferta completa
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}